/**
 * @todo
 * Waiting for next stage to implement this feature.
 * Integrate CTA blocks here.
 */

import { Renderer } from "@with-nx/cms-ui";
import {
  Formatter,
  useCMSClients,
  useDebug,
  useMobile,
} from "@with-nx/hooks-n-helpers";
import { Rule } from "@with-nx/simple-ui/atoms";
import {
  CatalogLayout,
  GenericContentHolder,
  GridBlog,
  GridStepScroller,
  ReusableGradientHero,
  ReusablePreSlantedContainer,
  ReusableSlantedContainer,
} from "@with-nx/simple-ui/organisms";
import { Col, Row } from "antd";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { Box } from "simple-effing-primitive-layout";

export default function Page({ resolvedUrl }) {
  const router = useRouter();
  const mobile = useMobile();
  const clients = useCMSClients(
    {
      filter: {
        slug: [router.query.slug as string],
      },
    },
    typeof router.query.slug === "string"
  );
  const all = useCMSClients({
    page: 0,
    per: 3,
  });

  const client = clients.clients.find(
    (item) => item.slug === router.query.slug
  );

  const debug = useDebug();

  useEffect(() => {
    if (!clients.loading && !client?._id) {
      router.replace("/404");
    }
  }, [clients.loading, client?._id]);

  if (!client) {
    return null;
  }

  const image = Formatter.image(client.image);

  return (
    <CatalogLayout
      footerNoAngle
      transparentFixedNavBar
      title={
        client?.title ? `Broadway Media - Client - ${client.title}` : undefined
      }
      description={client?.description}
      resolvedUrl={resolvedUrl}
    >
      <ReusableGradientHero
        slanted={false}
        backdrop="/assets/hero/homepage-gradient-webp.webp"
      />
      <ReusableSlantedContainer>
        <Box height={300} />
      </ReusableSlantedContainer>
      <Box
        parse={
          mobile
            ? "p:relative t:-600 i:2 mb:-600"
            : "p:relative t:-700 i:2 mb:-700"
        }
      >
        <div className="container mx-auto max-w-7xl">
          <Row gutter={[36, 18]} justify="center">
            <Col xs={24} sm={24} md={24} lg={20} xl={16}>
              <Box
                parse={mobile ? "pa:10 br:5 mb:24" : "pa:24 br:10 mb:24"}
                color="var(--foreground)"
                border="1px solid rgba(255,255,255,0.1)"
              >
                {debug ? (
                  <>
                    <Row gutter={[36, 18]}>
                      <Col xs={24} sm={12}>
                        <GenericContentHolder
                          image={image}
                          properties={{ bottom: 24 }}
                          parse="br:5 oa:hidden mb:24"
                          alt={client.title || "Client Image"}
                        />
                      </Col>
                      <Col xs={24} sm={12}>
                        <Rule rule="hs" display="block" bottom={24}>
                          {client.title}
                        </Rule>
                        <Rule rule="ls" display="block" bottom={24}>
                          {client.description}
                        </Rule>
                        <Renderer data={client.content} />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <GenericContentHolder
                      image={image}
                      properties={{ bottom: 24 }}
                      parse="br:5 oa:hidden mb:24"
                      alt={client.title || "Client Image"}
                    />
                    <Rule rule="hs" display="block" bottom={24}>
                      {client.title}
                    </Rule>
                    <Rule rule="ls" display="block" bottom={24}>
                      {client.description}
                    </Rule>
                    <Renderer data={client.content} />
                  </>
                )}
              </Box>
              <Rule
                rule="ht"
                color="var(--font1)"
                display="block"
                bottom={24}
                top={24}
              >
                More Clients
              </Rule>
              <ReusablePreSlantedContainer>
                <GridStepScroller
                  xs={24}
                  sm={24}
                  md={12}
                  lg={8}
                  xl={8}
                  items={all.clients
                    ?.filter((i) => i.slug !== router.query?.slug)
                    .map((client, c) => {
                      if (c > 3) {
                        return null;
                      }

                      return (
                        <GridBlog
                          key={client._id}
                          description={client.description}
                          image={Formatter.compressed(client.image, 256, true)}
                          title={client.title}
                          url={`/clients/${client.slug}`}
                          transparent={false}
                          properties={{
                            height: "100%",
                          }}
                        />
                      );
                    })}
                />
              </ReusablePreSlantedContainer>
            </Col>
          </Row>
        </div>
      </Box>
    </CatalogLayout>
  );
}

export const getServerSideProps = async ({ resolvedUrl }) => {
  return {
    props: {
      resolvedUrl,
    },
  };
};
